import { Card } from '@mui/material';
import { createSelector } from '@reduxjs/toolkit';
import { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { isSmallBusiness } from '../../../../domain/qualification';
import { selectBusinessInfo } from '../../../application/reducers/business-info';
import { selectPersonalInfo } from '../../../application/reducers/personalInfo';
import { PersonReviewDetails } from '../person-review-details';

const selectData = createSelector(
  [selectPersonalInfo, selectBusinessInfo],
  (personalInfo, { businessInfo: business }) => ({
    personalInfo,
    business,
  }),
);

const ApplicantInfoCard = (): ReactElement => {
  const { personalInfo, business } = useSelector(selectData);
  const smallBusiness = isSmallBusiness(business);

  return (
    <Card variant="outlined" sx={{ p: 4 }}>
      <PersonReviewDetails
        personalInfo={personalInfo}
        includeControlInfo={smallBusiness}
        includeOwnerInfo={smallBusiness}
      />
    </Card>
  );
};

export { ApplicantInfoCard };
